export default Object.freeze({
  Pending: 1,
  Active: 2,
  LookingForAgent: 3,
  Closed: 4,
  Archived: 5,
});
